import React, { useState, useEffect, useCallback, useRef } from "react";
import { FormGroup, Input, Col, Row, Modal, Button, Form, Label } from "reactstrap";
import { CustomButton } from "components/Button/CustomButton";
import CustomThumbnailField from "components/CustomThumbnailField/CustomThumbnailField";
import PaymentDetails from "components/Payment/PaymentDetails";
import MFABlock from "components/MFABlock/MFABlock";
import ReactBSAlert from "react-bootstrap-sweetalert";
import BlockUI from "components/Misc/BlockUI";

const AccountantDetailsForm = ({ data, selectedAccountant, userDetails, firmDetails, isAddNewAdmin, ...props }) => {
  const [openMultiFactorModal, setOpenMultiFactorModal] = useState(false);
  const [enableMultiFactor, setEnableMultiFactor] = useState(false);
  const [isMySQLAccessExist, setIsMySQLAccessExist] = useState(true);
  const [isManuallyAddedUser, setIsManuallyAddedUser] = useState(true);
  const [username, setusername] = useState('');
  const [password, setpassword] = useState('');
  const [showBlockUI, setShowBlockUI] = useState(false);
  const [selectedUserDetails, setSelectedUserDetails] = useState(null);
  const [selectedUserBusinessList, setSelectedUserBusinessList] = useState(null);
  const [selectedUserWithAccessBusinessList, setSelectedUserWithAccessBusinessList] = useState(null);
  const [isMultiBusinessUser, setIsMultiBusinessUser] = useState(false);
  const [existingMySQLAccess, setExistingMySQLAccess] = useState(null);
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [alert, setalert] = useState(false);
  const hasRun = useRef(false);

  useEffect(() => {
    // console.log('AccountantDetailsForm', selectedAccountant);
    // console.log('userDetails', userDetails);
    setSelectedUserDetails(selectedAccountant ?? userDetails);
  }, [selectedAccountant, userDetails, data]);

  const existingUserWithAccess = [
    { Username: "Deb@etani.au", Password: "xB6tqyd64R39", Firm: "advise" },
    { Username: "diane@etani.au", Password: "gjaf8OI3STTg", Firm: "advise" },
    { Username: "erin@etani.au", Password: "bVQMG2zlsWWw", Firm: "advise" },
    { Username: "jacinta@etani.au", Password: "U4YLMfrxOutJ", Firm: "advise" },
    { Username: "Kristel@etani.au", Password: "psAEtJ92c4cA", Firm: "advise" },
    { Username: "leslieq@etani.au", Password: "eb4e6d8e9a71", Firm: "advise" },
    { Username: "matt@etani.au", Password: "46bXMdRgroQI", Firm: "advise" },
    { Username: "jeremyheng@etani.au", Password: "jvdyWrzDXdqa", Firm: "austasiagroup" },
    { Username: "leslieq@etani.au", Password: "eb4e6d8e9a71", Firm: "austasiagroup" },
    { Username: "simon@etani.au", Password: "CRBUEThMK5pr", Firm: "austasiagroup" },
    { Username: "Kristel@etani.au", Password: "psAEtJ92c4cA", Firm: "beautifuldata" },
    { Username: "leslieq@etani.au", Password: "eb4e6d8e9a71", Firm: "beautifuldata" },
    { Username: "Craigs@etani.au", Password: "x1GJqSpMxjSc", Firm: "enspira" },
    { Username: "Kristel@etani.au", Password: "psAEtJ92c4cA", Firm: "enspira" },
    { Username: "leslieq@etani.au", Password: "eb4e6d8e9a71", Firm: "enspira" },
    { Username: "branniell.galang@etani.au", Password: "X3coMCVbyio4", Firm: "mksgroup" },
    { Username: "kristian.said@etani.au", Password: "z34a03p1DtKQ", Firm: "mksgroup" },
    { Username: "mark.said@etani.au", Password: "VYnZpU9d8OpT", Firm: "mksgroup" },
    { Username: "patrick.carrier@etani.au", Password: "9Kuv2cFpC9xE", Firm: "mksgroup" },
    { Username: "samuel.lucas@etani.au", Password: "vLgYcIRlt5Wd", Firm: "momentumdoctors" },
    { Username: "brendan@etani.au", Password: "D036GZQ8cFVP", Firm: "nextda" },
    { Username: "leslieq@etani.au", Password: "eb4e6d8e9a71", Firm: "nextda" },
    { Username: "John@etani.au", Password: "kvPib2617Rko", Firm: "rjsanderson" },
    { Username: "prashant@etani.au", Password: "yAaLzfAnl5DS", Firm: "rjsanderson" },
    { Username: "ravixkumar90@etani.au", Password: "bXbznXeLpQUl", Firm: "rjsanderson" },
    { Username: "bmarchione@etani.au", Password: "f6c98751d93a", Firm: "sw-au" },
    { Username: "jling@etani.au", Password: "b26a5ca5d921", Firm: "sw-au" },
    { Username: "leslieq@etani.au", Password: "eb4e6d8e9a71", Firm: "sw-au" },
    { Username: "rjamal@etani.au", Password: "e03f0e15d93a", Firm: "sw-au" },
    { Username: "rhemphill@etani.au", Password: "906fa34ad921", Firm: "sw-au" },
    { Username: "ssmith@etani.au", Password: "055a90aed93b", Firm: "sw-au" },
    { Username: "smuthukumaran@etani.au", Password: "eb4e6d8e9a71", Firm: "sw-au" },
    { Username: "Yuktha@etani.au", Password: "610efc03d921", Firm: "sw-au" },
    { Username: "imke.hoepfner@etani.au", Password: "r6VGAcF3yXIS", Firm: "ubtaccountants" },
    { Username: "kristina.silby@etani.au", Password: "1yLBfQxDpNwh", Firm: "ubtaccountants" },
    { Username: "leslieq@etani.au", Password: "eb4e6d8e9a71", Firm: "ubtaccountants" },
    { Username: "Nathan.Prestidge@etani.au", Password: "rj8dieoIuP8E", Firm: "ubtaccountants" },
    { Username: "Neville.Kennerley@etani.au", Password: "zL4sKBOhhqPb", Firm: "ubtaccountants" },
    { Username: "justin@etani.au", Password: "Ys6TegWqL4ow", Firm: "sudburys" },
    { Username: "nikita@etani.au", Password: "u8VgZpYYrnTb", Firm: "sudburys" },
    { Username: "stephen@etani.au", Password: "K52QSRAbynbV", Firm: "sudburys" },
    { Username: "victoria@etani.au", Password: "U8jZRxR7TVCO", Firm: "sudburys" },
    { Username: "Accounts@etani.au", Password: "RkF5ybWIfeDf", Firm: "sudburys" },
    { Username: "luism@etani.au", Password: "vu7JUMIf0bQ1", Firm: "enspira" },
    { Username: "ak@etani.au", Password: "LFwX3p5geZEq", Firm: "powertynan" },
    { Username: "bdt@etani.au", Password: "jPZIBbVAwTsF", Firm: "powertynan" },
    { Username: "Brad@etani.au", Password: "9PS1vQBe4ybW", Firm: "powertynan" },
    { Username: "chr@etani.au", Password: "Y3CHMu6Dz5hu", Firm: "powertynan" },
    { Username: "db@etani.au", Password: "61nD93Vd9WeZ", Firm: "powertynan" },
    { Username: "et@etani.au", Password: "QHzLVaBg0CTG", Firm: "powertynan" },
    { Username: "Gilda@etani.au", Password: "r2KaQl74nwVU", Firm: "powertynan" },
    { Username: "jk@etani.au", Password: "LNZ71wbbtpNg", Firm: "powertynan" },
    { Username: "ng@etani.au", Password: "OJzh3CiSdrQ2", Firm: "powertynan" },
    { Username: "ns@etani.au", Password: "fLBYLUyeH7uK", Firm: "powertynan" },
    { Username: "pbh@etani.au", Password: "3cf2cvjvfELh", Firm: "powertynan" },
    { Username: "pdr@etani.au", Password: "qQBSsIvE7I3K", Firm: "powertynan" },
    { Username: "sac@etani.au", Password: "Oh8p6pmTfRJB", Firm: "powertynan" },
    { Username: "stacey@etani.au", Password: "AHDZ8LEtaNIE", Firm: "powertynan" },
    { Username: "jamie@etani.au", Password: "9JBFCDGrH9sb", Firm: "blumetric" },
    { Username: "claire.gibbons@etani.au", Password: "2Vq6IjIFimFX", Firm: "williambuck-wa" },
    { Username: "yuxuan.gao@etani.au", Password: "LzczRCsUEMo7", Firm: "williambuck-wa" },
    { Username: "wa.xero@etani.au", Password: "vLtO2j8BN1do", Firm: "williambuck-wa" },
    { Username: "accounts.ahp@etani.au", Password: "PEJLBfHOqlIo", Firm: "ahp" },
    { Username: "lachlan.bonser@etani.au", Password: "9a47d6ed3833", Firm: "lbadvisory" },
    { Username: "leslieq@etani.au", Password: "eb4e6d8e9a71", Firm: "lbadvisory" },
    { Username: "maricel.garcia@etani.au", Password: "f9652957786e", Firm: "lbadvisory" },
    { Username: "BIAdmin@etani.au", Password: "E6QaqJ1eA9Gr", Firm: "visionbi" },
    { Username: "Matthew.Dodds@etani.au", Password: "f5zLNRwrlDZI", Firm: "visionbi" },
    { Username: "swathi.chatlaparthy@etani.au", Password: "ElozTIzjZ0Hd", Firm: "visionbi" },
    { Username: "victor@etani.au", Password: "q3ybhYrwwJal", Firm: "visionbi" }
  ];

  const handleEnableMultiFactor = () => {
    setOpenMultiFactorModal(!openMultiFactorModal);
    setEnableMultiFactor(!enableMultiFactor);
  };

  const closeMultiFactorModal = () => {
    // console.log(enableMultiFactor);
    setOpenMultiFactorModal(false);
    setEnableMultiFactor(false);
  };

  const loadMBUData = async () => {
    // console.log('loadMBUData() is running!', selectedUserDetails, selectedAccountant);
    setShowBlockUI(true);
    try {
      if (!selectedUserDetails || !selectedUserDetails.User || !selectedUserDetails.User.id) {
        console.log('No user ID available');
        setShowBlockUI(false);
        return { isMultiUser: false, businessList: [], MySQLAccess: null };
      }

      const ubRecord = await fetch(`/api/accountant/getAllUserBusiness/${selectedUserDetails.User.id}`);
      const ubRecordResult = await ubRecord.json();
      if (ubRecordResult.data && !ubRecordResult.data.error) {
        const data = ubRecordResult.data;
        let MySQLAccess;
        let noAccessCount = 0;
        let busWOAccess = [];

        for (const item of data) {
          if (!item.Details.Authority.MySQLAccess) {
            busWOAccess.push(item);
            noAccessCount++;
          } else {
            const { accountcode, _username, _password } = item.Details.Authority.MySQLAccess[0];
            MySQLAccess = {
              'accountcode': accountcode,
              '_username': _username,
              '_password': _password
            };
          }
        }

        setIsMultiBusinessUser(data.length > 1);

        const allBusinessPerMBU = await fetch(`/api/trialUser/getAllBusinessesPerMBUbyUserId/${selectedUserDetails.User.id}`);
        const allBusinessPerMBUResult = await allBusinessPerMBU.json();
        const businessList = [];
        const businessWithAccessList = [];

        if (allBusinessPerMBUResult.record && !allBusinessPerMBUResult.error) {
          const businesses = allBusinessPerMBUResult.record;
          for (const business of businesses) {
            const buss = busWOAccess.find(b => b.Business === business.id);
            businessWithAccessList.push({ id: business.id, business: business.Code });
            if (buss)
              businessList.push({ id: business.id, business: business.Code });
          }
          setSelectedUserBusinessList(businessList);
          setSelectedUserWithAccessBusinessList(businessWithAccessList);
        }
        setShowBlockUI(false);
        return { isMultiUser: data.length > 1, businessList: businessList, MySQLAccess };
      }
    } catch (e) {
      console.log('Error in loadMBUData:', e);
    }
    setShowBlockUI(false);
    return { isMultiUser: false, businessList: [], MySQLAccess: null };
  };

  const checkMySQLGrantAccess = useCallback(async () => {
    // console.log('checkMySQLGrantAccess() is running with:', selectedUserDetails);
    try {
      if (!selectedUserDetails || !selectedUserDetails.User || !selectedUserDetails.User.id) {
        console.log('No valid user details available for checkMySQLGrantAccess');
        return;
      }

      const { isMultiUser, businessList, MySQLAccess } = await loadMBUData();

      if (isMultiUser) {
        processMySQLAccessMultiBusinessUser(isMultiUser, businessList, MySQLAccess);
        return;
      }

      if (!MySQLAccess) {
        const matchedUser = validateManuallyAddedUser();
        if (matchedUser) {
          console.log("User access existed, manually added.");
        } else {
          console.log("User does not have MySQL access for this firm.");
        }
        setIsMySQLAccessExist(false);
      } else {
        setusername(MySQLAccess._username);
        setpassword(MySQLAccess._password);
        setIsMySQLAccessExist(true);
        setShowBlockUI(false);
      }
    } catch (e) {
      console.log(e);
      setShowBlockUI(false);
    }
    setShowBlockUI(false);
  }, [selectedUserDetails, data, firmDetails]);

  const validateManuallyAddedUser = () => {
    const username = data.UserName.split('@')[0] + '@etani.au';
    const matchedUser = existingUserWithAccess.find(
      (user) => user.Username.toLowerCase() === username.toLowerCase()
    );
    return matchedUser;
  };

  const processMySQLAccessMultiBusinessUser = async (isMultiUser, businessList, existingMySQLAccess) => {
    const matchedUser = validateManuallyAddedUser();
    if (businessList.length === 0) {
      const accountcode = firmDetails.Code;
      const MySQLAccess = [{
        'accountcode': accountcode,
        '_username': existingMySQLAccess._username,
        '_password': existingMySQLAccess._password
      }];

      let newPayload = data;
      newPayload.MySQLAccess = MySQLAccess;
      if (typeof props.handleSetPayload === "function")
        props.handleSetPayload(data);

      setusername(existingMySQLAccess._username);
      setpassword(existingMySQLAccess._password);
    } else {
      const uuid = existingMySQLAccess ? existingMySQLAccess._password : matchedUser ? matchedUser.Password : generateUUID();
      const username = data.UserName.split('@')[0] + '@etani.au';

      setusername(username);
      setpassword(uuid);

      const MySQLAccess = [{
        'accountcode': firmDetails.Code,
        '_username': username,
        '_password': uuid
      }];

      for (const business of businessList) {
        setExistingMySQLAccess({ username: username, password: uuid });
        let newPayload = data;
        newPayload.MySQLAccess = MySQLAccess;
        executeMySQLAccess(business.business, username, uuid);
      }
      processMultiBusinessSavingCredentials(MySQLAccess, businessList);
    }
    setShowBlockUI(false);
  };

  const processMultiBusinessSavingCredentials = (MySQLAccess, businessList) => {
    try {
      fetch(`/api/accountant/updateMultipleAuthority`, {
        method: "PUT",
        credentials: "include",
        body: JSON.stringify({
          Admin: data.Admin,
          AnalyticsDashboardReportGreen: data.AnalyticsDashboardReportGreen,
          AnalyticsDashboardReportOrange: data.AnalyticsDashboardReportOrange,
          AnalyticsDashboardReports: data.AnalyticsDashboardReports,
          Chat: data.Chat,
          PermanentDocs: data.PermanentDocs,
          PracticeManagerAccess: data.PracticeManagerAccess,
          PushNotifications: data.PushNotifications,
          ThirdPartyConnectors: data.ThirdPartyConnectors,
          MySQLAccess: MySQLAccess ? MySQLAccess : data.authority.MySQLAccess,
          businessList: businessList,
          userId: selectedUserDetails.User.id
        }),
      });
    } catch (e) {
      console.log(e);
    }
  };

  const handleResetPasswordAlert = (e) => {
    e.preventDefault();
    setalert(
      <ReactBSAlert
        warning
        title="Warning"
        onConfirm={() => handleResetPassword()}
        onCancel={() => setalert(null)}
        confirmBtnBsStyle="warning"
        confirmBtnText="Confirm"
        btnSize=""
        showCancel={true}
      >
        <p>
          Are you sure you want to reset your MySQL access password?
        </p>
      </ReactBSAlert>
    );
  };

  const handleResetPassword = async () => {
    setalert(null);
    setShowBlockUI(true);
    const uuid = generateUUID();
    const userEmail = data?.UserName;
    const username = userEmail.split('@')[0] + '@etani.au';
    setpassword(uuid);

    const MySQLAccess = [{
      'accountcode': selectedUserWithAccessBusinessList[0].business,
      '_username': username,
      '_password': uuid
    }];

    try {
      setExistingMySQLAccess({ username: username, password: uuid });
      processMultiBusinessSavingCredentials(MySQLAccess, selectedUserWithAccessBusinessList);

      const query = `ALTER USER '${username}'@'%' IDENTIFIED BY '${uuid}';`;
      const body = {
        'query': query
      };
      await fetch("/api/user/executeMySQLAccess", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      setShowBlockUI(false);
      successAlert("Record has been updated successfully");
    } catch (e) {
      errorAlert(e);
      setShowBlockUI(false);
    }
  };

  const executeMySQLAccess = async (business, username, uuid) => {
    console.log('executeMySQLAccess() is running!');
    // console.log('business', business);
    // console.log('username', username);
    // console.log('uuid', uuid);
    const formattedUserName = username.split('@')[0] + `@${business}.au`;
    // console.log('formattedUserName', formattedUserName);
    const query = `call Grant_Select_Access_XeroBlue('${business}', '${formattedUserName}', '${uuid}');`;
    try {
      const body = {
        'query': query
      };
      const details = await fetch("/api/user/executeMySQLAccess", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      const data = await details.json();
    } catch (e) {
      console.log(e);
    }
  };

  const generateUUID = () => {
    let uuid = '';
    const characters = 'abcdef0123456789';
    for (let i = 0; i < 12; i++) {
      uuid += characters[Math.floor(Math.random() * characters.length)];
    }
    return uuid;
  };

  const successAlert = (message) => {
    setalert(
      <ReactBSAlert
        success
        title="Success"
        onConfirm={() => setalert(null)}
        onCancel={() => setalert(null)}
        confirmBtnBsStyle="success"
        confirmBtnText="Ok"
        btnSize=""
      >
        {message}
      </ReactBSAlert>
    );
  };

  const errorAlert = (message) => {
    setalert(
      <ReactBSAlert
        danger
        title="Error"
        onConfirm={() => setalert(null)}
        onCancel={() => setalert(null)}
        confirmBtnBsStyle="danger"
        confirmBtnText="Ok"
        btnSize=""
      >
        {message}
      </ReactBSAlert>
    );
  };

  const handleShowPassword = () => {
    setIsShowPassword(!isShowPassword);
  };

  useEffect(() => {
    // console.log('Effect running with:', {
    //   data: data,
    //   selectedUserDetails: selectedUserDetails,
    //   userAccess: userDetails?.User?.UserAccess,
    //   firmDetails: firmDetails
    // });
    
    if (!data || Object.keys(data).length === 0) {
      console.log('Returning early: data is empty');
      return;
    }
    if (!selectedUserDetails || !selectedUserDetails.User) {
      console.log('Returning early: selectedUserDetails is invalid');
      return;
    }
    if (selectedUserDetails.User.UserAccess < 5) {
      // console.log('Calling checkMySQLGrantAccess with:', selectedUserDetails);
      checkMySQLGrantAccess();
    } else {
      console.log('User access >= 5, not calling checkMySQLGrantAccess');
    }
  }, [data, firmDetails, selectedUserDetails]);

  useEffect(() => {
    if (!isMySQLAccessExist && !hasRun.current) {
      processMySQLGrantAccess();
      hasRun.current = true;
    }
  }, [isMySQLAccessExist]);

  const processMySQLGrantAccess = useCallback(async () => {
    try {
      console.log('processMySQLGrantAccess() is running!');

      const matchedUser = validateManuallyAddedUser();

      const uuid = matchedUser ? matchedUser.Password : generateUUID();
      const username = data.UserName.split('@')[0] + '@etani.au';
      const accountcode = firmDetails.Code;
      const MySQLAccess = [{
        'accountcode': accountcode,
        '_username': username,
        '_password': uuid
      }];

      setusername(username);
      setpassword(uuid);

      let newPayload = data;
      newPayload.MySQLAccess = MySQLAccess;

      if (typeof props.handleSetPayload === "function")
        props.handleSetPayload(newPayload);

      handleSaveMySQLAccess(newPayload.MySQLAccess, false, accountcode, username, uuid);
    } catch (e) {
      console.log(e);
    }
  }, [isMySQLAccessExist]);

  const handleSaveMySQLAccess = async (MySQLAccess, isEditMySQLAccess = false, business, username, uuid) => {
    if (typeof props.handleUpdateAuthority === "function") {
      props.handleUpdateAuthority(MySQLAccess, isEditMySQLAccess);
    }
    executeMySQLAccess(business, username, uuid);
  };

  const isSameEmail = () => {
    if (data === undefined || Object.keys(data).length === 0) return true;
    return data?.Email.toLowerCase() === userDetails?.User.Email.toLowerCase() || 
           (userDetails?.User.Email.toLowerCase() === 'admin@etani-bp.com.au' || 
            userDetails?.User.Email.toLowerCase() === 'jp@etani.com.au');
  };

  const renderCardIcon = (brand) => {

    let cardLogo = ''

    switch (brand) {
      case "amex":
        cardLogo = "amex"
        break;
      case "diners":
        cardLogo = "diners"
        break;
      case "discover":
        cardLogo = "discover"
        break;
      case "jcb":
        cardLogo = "jcb"
        break;
      case "mastercard":
        cardLogo = "mastercard"
        break;
      case "unionpay":
        cardLogo = "unionpay"
        break;
      case "visa":
        cardLogo = "visa"
        break;
      default:
        // code block
        cardLogo = "unknown"
    }


    return (
      <img
        style={{
          background: "#eee",
          width: "auto",
          height: "20px",
          objectFit: "contain",
          // borderRadius: "10px",
          // border: "2px solid #e2e2e2",
        }}
        alt="..."
        // className="rounded-circle"
        src={require(`assets/img/cards/${cardLogo}.png`).default}
      />
    )
  }

  return (
    <>
      {isSameEmail() && !isAddNewAdmin &&
        <>
          {alert}
          {showBlockUI ? <BlockUI /> : null}
          <>
          <FormGroup>
            <label className="form-control-label mb-3">
              PowerBI MySQL Access
            </label>
            <Row>
              <Col sm='12' md='6'>
                <FormGroup>
                  <label className="form-control-label" htmlFor="_username">
                    Username
                  </label>
                  <Input
                    type="text"
                    id="_username"
                    disabled
                    value={username}
                    autoComplete="username"
                    className="getData"
                  />
                </FormGroup>
              </Col>
              <Col sm='12' md='6'>
                <FormGroup>
                  <label className="form-control-label" htmlFor="_password">
                    Password
                  </label>
                  <div className="d-flex align-items-center">
                    <div className="position-relative w-100">
                      <Input
                        type={isShowPassword ? "text" : "password"}
                        id="_password"
                        disabled
                        value={password}
                        autoComplete="current-password"
                        className="getData pr-5"
                      />
                      <div 
                        className="position-absolute" 
                        style={{ 
                          right: '10px', 
                          top: '50%', 
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                          zIndex: 2
                        }}
                        onClick={handleShowPassword}
                      >
                        <i className={`fas ${isShowPassword ? 'fa-eye-slash' : 'fa-eye'}`} />
                      </div>
                    </div>
                    <Button 
                      color="warning" 
                      type="button" 
                      className="ml-2 d-flex align-items-center justify-content-center"
                      style={{ height: '38px' }}
                      onClick={handleResetPasswordAlert}
                    >
                      Reset
                    </Button>
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </FormGroup>
          <hr className="my-4" style={{ borderTop: '1px solid #ececec' }} />
        </>
        </>
      }
      <Modal
        className="modal-dialog-top"
        isOpen={enableMultiFactor}
        toggle={() => handleEnableMultiFactor()}
        size="lg"
        backdrop="static"
      >
        <div className="modal-header">
          <h6 className="modal-title">{"Setup Multi Factor Authentication"}</h6>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => closeMultiFactorModal()}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          <FormGroup>
            <label className="form-control-label" htmlFor="6digit">
              6-digit Code
            </label>
            <Input
              placeholder="6-digit Code"
              type="text"
              name="6-digit Code "
              // required={true}
              id="6digit"
              onChange={props.handleInputChange}
              className="getData"
            />
          </FormGroup>
        </div>
        <div className="modal-footer">
          <CustomButton
            type="button"
            onClick={() => handleEnableMultiFactor()}
            outlineStyle={false}
            title="Save changes"
          />
          <CustomButton
            className="ml-auto"
            color="link"
            data-dismiss="modal"
            type="button"
            onClick={() => closeMultiFactorModal()}
            outlineStyle={true}
            title="Close"
          />
        </div>
      </Modal>
      {
        props.showPaymentInfo ?
          <>
            <PaymentDetails userPaymentDetails={props.userPaymentDetails} handleShowPaymentInfo={props.handleShowPaymentInfo} />
          </>
          :
          <>
            {/* {userDetails?.User?.Details?.MFAEnabled ? <MFABlock userDetails={userDetails} /> : ''} */}
            <FormGroup>
              <label className="form-control-label" htmlFor="Email">
                Email <span className="text-warning">*</span>
              </label>
              <Input
                placeholder="Email"
                type="email"
                name="Email"
                required={true}
                id="Email"
                onChange={props.handleInputChange}
                defaultValue={data && data.Email ? data.Email : ""}
                className="getData"
                style={{
                  border: props.isEmailValid ? "1px solid #dee2e6" : "1px solid red",
                }}
                disabled={props.modalTitle === "Add Admin" ? false : true}
              />
              {props.isEmailValid ? (
                ""
              ) : (
                <small className="text-warning">Email is not valid.</small>
              )}
            </FormGroup>
            {props.userAccess <= 4 || props.isUpdate ? (
              (firmDetails?.Details?.PbiEnabled && firmDetails?.PricingPlan.Code === 'TIER6') || firmDetails?.PricingPlan.id <= 19 ?
              <FormGroup>
                <label className="form-control-label" htmlFor="PowerBIEmail">
                  Power BI Email <span className="text-warning">*</span>
                </label>
                <Input
                  placeholder="PowerBI Email"
                  type="email"
                  name="PowerBIEmail"
                  required={true}
                  id="PowerBIEmail"
                  onChange={props.handleInputChange}
                  defaultValue={data && data.UserName ? data.UserName : ""}
                  className="getData"
                  style={{
                    border: props.isEmailValid
                      ? "1px solid #dee2e6"
                      : "1px solid red",
                  }}
                  disabled={props.modalTitle === "Add Admin" ? false : true}
                />
                {props.isEmailValid ? (
                  ""
                ) : (
                  <small className="text-warning">Email is not valid.</small>
                )}
              </FormGroup>
              : null
            ) : null}
            <FormGroup>
              <label className="form-control-label" htmlFor="FirstName">
                First Name <span className="text-warning">*</span>
              </label>
              <Input
                placeholder="First Name"
                type="text"
                name="FirstName"
                required={true}
                id="FirstName"
                onChange={props.handleInputChange}
                defaultValue={data && data.FirstName ? data.FirstName : ""}
                className="getData"
                style={{
                  border: props.isFirstNameValid
                    ? "1px solid #dee2e6"
                    : "1px solid red",
                }}
              />
              {props.isFirstNameValid ? (
                ""
              ) : (
                <small className="text-warning">This field is required.</small>
              )}
            </FormGroup>
            <FormGroup>
              <label className="form-control-label" htmlFor="LastName">
                Last Name <span className="text-warning">*</span>
              </label>
              <Input
                placeholder="Last Name"
                type="text"
                name="LastName"
                required={true}
                id="LastName"
                onChange={props.handleInputChange}
                defaultValue={data && data.LastName ? data.LastName : ""}
                className="getData"
                style={{
                  border: props.isLastNameValid
                    ? "1px solid #dee2e6"
                    : "1px solid red",
                }}
              />
              {props.isLastNameValid ? (
                ""
              ) : (
                <small className="text-warning">This field is required.</small>
              )}
            </FormGroup>
            {props.userAccess >= 5 ? null : (
              <FormGroup>
                <label className="form-control-label" htmlFor="Phone">
                  Phone Number
                  {/* <span className="text-warning">*</span> */}
                </label>
                <Input
                  placeholder="Phone Number"
                  type="text"
                  name="Phone"
                  required={true}
                  id="Phone"
                  onChange={props.handleInputChange}
                  defaultValue={data && data.Phone ? data.Phone : ""}
                  className="getData"
                // style={{
                //   border: props.isPhoneValid
                //     ? "1px solid #dee2e6"
                //     : "1px solid red",
                // }}
                />
                {/* {props.isPhoneValid ? (
                  ""
                ) : (
                  <small className="text-warning">This field is required.</small>
                )} */}
              </FormGroup>
            )}
            <Row>
              <Col>
                <CustomThumbnailField
                  id="Logo"
                  name="Logo"
                  help="Avatar"
                  onChange={props.handleInputChange}
                  value={
                    props.isLoading && !data.Avatar
                      ? require("assets/img/blank-avatar.png").default
                      : data.Avatar
                  }
                  label="Avatar"
                  alt="Logo"
                  lang="en"
                  record={data}
                  handleImgChange={props.handleImgChange}
                  withResetImage={true}
                />
              </Col>
            </Row>
            {props.userAccess >= 5 ? null : (
              <FormGroup>
                <label className="form-control-label" htmlFor="Sample">
                  Position <span className="text-warning">*</span>
                </label>
                <Input
                  placeholder="Position"
                  type="text"
                  name="Position"
                  required={true}
                  id="Position"
                  onChange={props.handleInputChange}
                  defaultValue={data && data.Position ? data.Position : ""}
                  className="getData"
                  style={{
                    border: props.isPositionValid
                      ? "1px solid #dee2e6"
                      : "1px solid red",
                  }}
                />
                {props.isPositionValid ? (
                  ""
                ) : (
                  <small className="text-warning">This field is required.</small>
                )}
              </FormGroup>
            )}
            {props.userAccess >= 5 ? null : (
              <FormGroup>
                <label className="form-control-label" htmlFor="Sample">
                  Description
                </label>
                <Input
                  placeholder="Description"
                  type="textarea"
                  name="Description"
                  required={true}
                  id="Description"
                  rows={4}
                  onChange={props.handleInputChange}
                  defaultValue={data && data.Description ? data.Description : ""}
                  className="getData"
                />
              </FormGroup>
            )}
            {props.onProfilePage ? (
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor="exampleFormControlInput1"
                >
                  Enable Multi Factor Authentication?
                </label>
                <div>
                  <Row>
                    <Col className="col-lg-1" xs="2">
                      <label className="custom-toggle custom-toggle-success mr-1">
                        <input
                          defaultChecked={enableMultiFactor}
                          type="checkbox"
                          onClick={handleEnableMultiFactor}
                          id="MultiAuth"
                          name="MultiAuth"
                        />
                        <span
                          className="custom-toggle-slider rounded-circle"
                          data-label-off="No"
                          data-label-on="Yes"
                        />
                      </label>
                    </Col>
                  </Row>
                </div>
              </FormGroup>
            ) : null}
          </>
      }
    </>
  );
};

export default AccountantDetailsForm;
